module.exports = __webpack_public_path__ + "img/ico-sun.6ffc860.svg";